Ext.define('SA.VectorMapLocationValidator', {
    constructor({model, activeState}) {
        this.model = model;
        this.activeState = activeState;

        this.initEvents();
        this.validate();
    },

    initEvents() {
        this.model.on('change:attribute', this.validate, this);
        this.model.on('change:location', this.validate, this);
    },

    validate() {
        var attribute = this.model.getAttribute(),
            geographicRelease = this.model.getGeographicRelease(),
            location = SA.data.LocationsCache.normalizeLocation(this.model.getLocation());

        if (this.activeState.isActive() && attribute && location && !SA.data.LocationsCache.isLocationAvailableInGeographicReleases(location, [geographicRelease])) {
            let attributeLabel = SA.data.AttributesCache.getLabel(attribute);

            if (location.type === 'combination') {
                SA.warn(`This combination location can’t be mapped because one or more of its constituent locations didn’t exist when the data for ‘${attributeLabel}’ was collected.`);
            }
            else {
                SA.warn(`This location can’t be mapped because it didn’t exist when the data for ‘${attributeLabel}’ was collected.`);
            }
        }
    }
});